export enum FileType {
  Unknown = 0,
  Ddd = 1,
  Gps = 2,
  Activity = 3,
  Absences = 4,
  Tms = 5,
  Chart = 6,
}
